import { gql } from '@apollo/client'

export const COMPANY_MANAGER_DASHBOARD_LIST_OF_COMPANIES = gql`
  query CompanyManagerDashboardListOfCompanies {
    companyManagerDashboardListOfCompanies {
      companyId
      companyName
      countries
      rolesOnCompany
    }
  }
`

export const COMPANY_MANAGER_DASHBOARD_PARTIAL_VISIBILITY = gql`
  query CompanyManagerDashboardPartialVisibility($companyId: HashedId!, $userDashboardRoles: [RoleName!]!) {
    companyManagerDashboardPartialVisibility(companyId: $companyId, userDashboardRoles: $userDashboardRoles)
  }
`
